import { render, staticRenderFns } from "./ItemForm.vue?vue&type=template&id=001b1ccc&"
import script from "./ItemForm.vue?vue&type=script&lang=js&"
export * from "./ItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports